import { Api } from '../../../../../providers/api';
import { BookingGroup } from '../../../../../entities/booking-group';
import { Component } from '@angular/core';
import { DepartureDetailsPage } from '../departure-details/departure-details';
import { NavController, NavParams, Platform } from 'ionic-angular';
import { PostSearchSailingsObject } from '../../../../../interfaces/api';
import { Sailing } from '../../../../../entities/sailing';
import { SpinnerDialog } from '@ionic-native/spinner-dialog';
import { VehicleType } from '../../../../../entities/vehicle-type';

type SailingType = 'outbound_sailing' | 'return_sailing';

@Component({
    selector: 'page-route',
    templateUrl: 'route.html',
})
export class RoutePage {

    target: SailingType = 'outbound_sailing';
    bookings: BookingGroup;
    sailings: Sailing[] = [];
    vehicleTypes: VehicleType[] = [];
    showingReturnSailing: boolean = false;

    constructor(
        private api: Api,
        private navCtrl: NavController,
        private navParams: NavParams,
        private platform: Platform,
        private spinner: SpinnerDialog,
    ) {
        this.showingReturnSailing = this.navParams.get('showingReturnSailing');
        if (this.showingReturnSailing === undefined)
            this.showingReturnSailing = false;

        this.bookings = this.navParams.get('bookings');
        this.vehicleTypes = this.navParams.get('vehicleTypes');


        if (this.showingReturnSailing)
            this.target = 'return_sailing';

        this.platform.ready().then(async () => {
            let sailingsRequest: PostSearchSailingsObject = this.buildSailingsRequestObject();
            this.sailings = await this.api.postSailings(sailingsRequest);
        });
    }

    async selectSailing(sailing: Sailing) {
        this.bookings[this.target] = sailing;
        this.spinner.show();

        if (this.bookings.is_return_journey && !this.showingReturnSailing) {
            this.navCtrl.push(RoutePage, {
                bookings: this.bookings,
                showingReturnSailing: true,
                vehicleTypes: this.intersectSailingVehicleTypes(),
            });
        } else {
            this.navCtrl.push(DepartureDetailsPage, {
                bookings: this.bookings,
                vehicleTypes: this.intersectSailingVehicleTypes(),
            });
        }

        this.spinner.hide();
    }

    intersectSailingVehicleTypes(): VehicleType[] {
        let types: VehicleType[] = [];

        if (!this.bookings.is_return_journey || this.bookings.return_sailing === undefined)
            return this.bookings.outbound_sailing.vehicle_types;

        for (let ovt of this.bookings.outbound_sailing.vehicle_types)
            for (let ivt of this.bookings.return_sailing.vehicle_types) {
                if (ovt.id !== ivt.id) continue;
                let found: boolean = false;
                for (let type of types)
                    if (ivt.id === type.id) found = true;

                if (!found) types.push(ivt);
            }

        return types;
    }

    isSelected(sailing: Sailing): boolean {
        if (this.bookings[this.target] === undefined) return false;
        if (this.bookings[this.target].id === undefined) return false;
        return this.bookings[this.target].id === sailing.id;
    }

    private buildSailingsRequestObject(): PostSearchSailingsObject {

        let bookingKey: string = !this.showingReturnSailing ? 'outbound_booking' : 'return_booking';

        let sailingsRequest: PostSearchSailingsObject = {
            departure_port_id: this.bookings[bookingKey].departure_port.id,
            arrival_port_id: this.bookings[bookingKey].arrival_port.id,
            date: this.bookings[bookingKey].departing_at.format('YYYY-MM-DD'),
        };

        if (this.bookings.shipping_line !== undefined)
            sailingsRequest.shipping_line_id = this.bookings.shipping_line.id;

        if (this.bookings.vehicle_type !== undefined)
            sailingsRequest.vehicle_type_id = this.bookings.vehicle_type.id;

        return sailingsRequest;
    }

}



// WEBPACK FOOTER //
// ./src/pages/bookings/my-bookings/create-booking/route/route.ts